import { IconProps } from '.';
const GroupIcon = ({ color, customClasses, ...rest }: IconProps) => {
  return (
    <svg
      className={customClasses}
      width="1em"
      height="1em"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5 6.80664C12.9061 6.80664 6.75 12.9627 6.75 20.5566C6.75 28.1506 12.9061 34.3066 20.5 34.3066C28.0939 34.3066 34.25 28.1506 34.25 20.5566C34.25 12.9627 28.0939 6.80664 20.5 6.80664ZM4.25 20.5566C4.25 11.582 11.5254 4.30664 20.5 4.30664C29.4746 4.30664 36.75 11.582 36.75 20.5566C36.75 29.5313 29.4746 36.8066 20.5 36.8066C11.5254 36.8066 4.25 29.5313 4.25 20.5566Z"
        fill={color}
      />
      <path
        d="M12.6621 15.9733C12.6621 18.0443 14.341 19.7233 16.4121 19.7233C18.4831 19.7233 20.1621 18.0443 20.1621 15.9733C20.1621 13.9022 18.4831 12.2233 16.4121 12.2233C14.341 12.2233 12.6621 13.9022 12.6621 15.9733Z"
        fill={color}
      />
      <path
        d="M22.9954 18.0566C22.9954 19.8976 24.4878 21.3899 26.3288 21.3899C28.1698 21.3899 29.6621 19.8976 29.6621 18.0566C29.6621 16.2157 28.1698 14.7233 26.3288 14.7233C24.4878 14.7233 22.9954 16.2157 22.9954 18.0566Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.4567 25.7839C17.5682 24.4992 13.0074 23.6962 8.74749 27.8715L7.05533 26.0902C12.3607 20.8903 18.1514 21.9744 21.5187 23.4721C22.1382 23.7476 22.4026 24.4884 22.1093 25.1268C21.8161 25.7652 21.0762 26.0594 20.4567 25.7839Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.1615 27.2566C30.3541 25.4649 26.0854 24.0648 21.5829 26.2071C20.6709 26.641 20.084 27.6933 20.084 28.9623V35.5559H17.584V28.9623C17.584 27.0012 18.5041 24.9034 20.5088 23.9496C26.0801 21.2988 31.2929 23.0983 34.5065 25.1492C35.0884 25.5206 35.2591 26.2935 34.8877 26.8754C34.5163 27.4573 33.7434 27.628 33.1615 27.2566Z"
        fill={color}
      />
    </svg>
  );
};

export default GroupIcon;
